export default "__VITE_ASSET__6c6ee0c2__"